import { Select as AntSelect, Tooltip } from 'antd';
import { CSSProperties, ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { QuestionMarkSvg } from '../../../assets/icons';

const { Option } = AntSelect;

type Props = {
  label?: string;
  fluid?: boolean;
  placeholder?: string;
  noBorder?: boolean;
  suffixIcon?: ReactNode;
  style?: CSSProperties;
  labelStyle?: CSSProperties;
  onChange?: (value: string | number | boolean | string[]) => void;
  options: { displayName: string; value: string | number | boolean }[];
  value?: string | number | boolean | string[];
  defaultValue?: string | number | boolean | string[];
  disabled?: boolean;
  showSearch?: boolean;
  onSearch?: (value: string) => void;
  tooltipText?: () => JSX.Element | string;
  onClear?: () => void;
  filterOption?: boolean | ((inputValue: string, option: any) => boolean);
  maxTagPlaceholder?: ReactNode | ((omittedValues: any[]) => ReactNode);
  maxTagCount?: number;
};
const MultiSelect = ({
  value,
  defaultValue,
  options,
  label,
  labelStyle,
  placeholder,
  noBorder,
  suffixIcon,
  fluid,
  style,
  disabled,
  showSearch,
  onSearch,
  tooltipText,
  onClear,
  onChange,
  filterOption,
  maxTagPlaceholder,
  maxTagCount,
}: Props) => {
  return (
    <Wrapper $fluid={fluid} style={style} $noBorder={noBorder}>
      {label && (
        <Label style={labelStyle ? labelStyle : {}}>
          {label}
          {tooltipText && (
            <Tooltip title={tooltipText}>
              <HelpIconWrapper>
                <QuestionMarkSvg />
              </HelpIconWrapper>
            </Tooltip>
          )}
        </Label>
      )}
      <AntSelect
        mode="multiple"
        allowClear
        showArrow
        onClear={onClear}
        value={value}
        disabled={disabled}
        defaultValue={defaultValue}
        style={{ cursor: 'pointer' }}
        showSearch={showSearch}
        onSearch={onSearch}
        placeholder={placeholder}
        onChange={onChange}
        filterOption={filterOption}
        maxTagPlaceholder={maxTagPlaceholder}
        maxTagCount={maxTagCount ? maxTagCount : 'responsive'}
        suffixIcon={suffixIcon}
      >
        {options.map(opt => (
          <Option
            key={opt.value === true ? 'true' : opt.value === false ? 'false' : opt.value}
            value={opt.value}
          >
            {opt.displayName}
          </Option>
        ))}
      </AntSelect>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $fluid?: boolean; $noBorder?: boolean }>`
  cursor: pointer;
  .ant-select {
    width: 100%;
  }
  &&& .ant-select .ant-select-selector {
    border: ${props => (props.$noBorder ? 'none' : '1px solid #d9d9d9')};
    border-radius: 5px;
    height: 42px;
    display: flex;
    align-items: center;
    font-size: 16px;
    ${props =>
      props.$fluid &&
      css`
        width: 100%;
      `}
  }

  &&& .ant-select-selection-item-content {
    font-weight: 400;
  }
  ${props =>
    props.$fluid &&
    css`
      height: 100%;
    `}
`;

const Label = styled.div`
  color: #a5a5a5;
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 4px;
`;

const HelpIconWrapper = styled.span`
  cursor: pointer;
  margin-left: 5px;
  svg {
    height: 16px;
    width: 16px;
  }
`;

export default MultiSelect;
